import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import PersistedContext from "../../context/persistedContext";
import drupal from "../../apis/drupal";
import { sendBooking } from "../../actions/bookingActions";
import useResources from "../../resources/useResource";
import useGoResources from "../../resources/useGoResource";
// import DealCard from "../../elements/DealCard";
import EnquiryForm from "../../elements/EnquiryForm";
import SocialContainer from "../../elements/SocialContainer";
import EnquireButton from "../../elements/EnquireButton";
import AvailabilitySearchContainer from "../../components/availability/AvailabilitySearchContainer";
import { BackgroundContext } from "../../context/BackgroundContext";
import { Container, Row, Col, Button, Modal, Card } from "react-bootstrap";
import Title from "../../elements/Title";
import Parser from "html-react-parser";
import _ from "lodash";
import { default as BASE } from "../../config";
import DealCarousel from "../../elements/DealCarousel";
import {
  renderCurrentDealList,
  packageFiltering,
  renderFileList,
  renderDestGuide,
  renderImageGallery,
  loader,
} from "../../helpers";
import { getFlyerDetail } from "../../helpers/goFlyerFunctions";
import DealTabbedContent from "./DealTabbedContent";
import { META } from "../../seo/meta";

//const queryString = require("query-string");

const DealPage = (props) => {
  const setBASE =
    process.env.REACT_APP_MODE === "goholsnz" ? "nz/deal/" : "au/deal/";

  const dispatch = useDispatch();

  const { packages } = useContext(PersistedContext);
  const data = useResources(`${setBASE}${props.match.params.id}`);
  const flyerData = useGoResources(`1`);
  //const itinerary = useResources(`viva/itinerary/2815`);
  const [pkgList, setPkgList] = useState([]);
  const [show, setShow] = useState(false);
  const [premPage, setPremPage] = useState(false);
  //const [content, setContent] = useState({});
  const { setImage } = useContext(BackgroundContext);
  const deal = data && data[0];
  const flyer = flyerData && flyerData.flyer;
  //deal && console.log(deal);
  //const title = props.match.params.title;

  const [soldOut, setSoldOut] = useState(false);

  let bookFlag = true;

  useEffect(() => {
    deal &&
      setImage(
        null,
        deal.field_vc_alt_background
          ? deal.field_vc_alt_background
          : deal.field_main_image
      );
    deal && deal.field_hide_related_list == 1 && setPremPage(true);
    deal && fetchData();
    //deal && fetchFlyerData();
    //const parsed = queryString.parse(props.location.search);
  }, [deal]);

  const fetchData = async () => {
    const res = await drupal.get(`/deals/${deal.nid_1}`);
    setPkgList(res.data);
  };

  //useEffect(() => {}, [flyer]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    // setContent(section);
  };

  const renderTvlBetween = (dates) => {
    const content = (
      <div className="travel-dates">
        <strong>For Travel Between: </strong>
        {_.map(dates, (date, id) => {
          return (
            <span key={id}>
              {date}
              {id < dates.length - 1 ? "," : ""}
            </span>
          );
        })}
      </div>
    );

    return content;
  };

  const renderPriceAddonLabel = (dates, priceAddList) => {
    let dateList = "";
    let max = _.max(priceAddList);

    let priceDateListArr = null;
    let priceDateTextArr = null;

    _.map(dates, (date, id) => {
      priceDateListArr = {
        ...priceDateListArr,
        [id]: { price: parseFloat(priceAddList[id]), date: date },
      };
    });

    priceDateListArr = _.sortBy(priceDateListArr, "price");

    _.map(dates, (date, id) => {
      if (priceAddList[id] > 0.01) {
        dateList += date;
        dateList += ",";
      }
    });

    let counter = 0;
    let dateText = "";

    _.map(priceDateListArr, (data, id) => {
      if (
        priceDateListArr[id + 1] &&
        parseFloat(priceDateListArr[id + 1].price) > parseFloat(data.price)
      ) {
        dateText += data.date;
        priceDateTextArr = {
          ...priceDateTextArr,
          [counter]: { price: data.price, text: dateText },
        };
        dateText = "";
        counter++;
      } else if (_.isEmpty(priceDateListArr[id + 1])) {
        dateText += data.date;
        priceDateTextArr = {
          ...priceDateTextArr,
          [counter]: { price: data.price, text: dateText },
        };
        dateText = "";
      } else {
        dateText += data.date + ",";
      }
    });

    const cont = (
      <div className="travel-dates mt-2 pl-1 pb-2 border-bottom border-light">
        {_.map(priceDateTextArr, (data, id) => {
          return data.price > 0.01 ? (
            <div className="mt-2" key={id}>
              <h6 className="m-0">{`Add on an extra $${data.price}* per person for travel on: `}</h6>
              <span>{data.text.replace(/,\s*$/, "")}</span>
            </div>
          ) : null;
        })}
      </div>
    );

    // const content = (
    //   <div className="travel-dates mt-2 pl-1 pb-2 border-bottom border-light">
    //     <h6 className="m-0">{`Add on an extra $${max.replace(
    //       ".00",
    //       ""
    //     )}* per person for travel on: `}</h6>
    //     <span>{dateList.replace(/,\s*$/, "")}</span>
    //   </div>
    // );

    return max > 0.01 ? cont : null;
  };

  const renderBookingConds = (conds) => {
    return (
      <div className="mt-3 text-left package-conditions small rounded">
        <h3 className="text-uppercase" title="Important Booking Conditions">
          Important Booking Conditions
        </h3>
        {Parser(conds)}
      </div>
    );
  };

  const renderEnquireBook = (pkg) => {
    if (
      pkg.field_vc_sell_online == 1 &&
      BASE.CONFIG.BOOKINGSALLOWED &&
      !soldOut
    ) {
      return <AvailabilitySearchContainer deal={pkg} setSoldOut={setSoldOut} />;
    }

    return <EnquireButton handleShow={handleShow} currentPackages={pkg} />;
  };

  const renderPriceBar = () => {
    if (deal.field_go_id > 1 && flyer) {
      const savings = deal.field_amount_saving;

      return (
        <div className="mt-4 d-flex priceNSavings">
          {savings && (
            <div className="text-uppercase saving-amount">
              {`Save ${savings}`}
            </div>
          )}
          <div className="ml-auto text-right d-flex mr-2">
            <div className="align-self-center justify-content-start pr-2">
              <span className="text-capitalize">{deal.field_booking_type}</span>
              <h6 className="text-white small">
                {`${deal.field_savings} ${deal.field_price_type}`} from:
              </h6>{" "}
            </div>
            <h2 className="pt-1 justify-content-end">
              {`${deal.field_package_price}`}{" "}
            </h2>
          </div>
        </div>
      );
    }

    if (deal.field_go_id < 1 && deal) {
      const savings = deal.field_amount_saving;

      return (
        <div className="mt-4 d-flex priceNSavings">
          {savings && (
            <div className="text-uppercase saving-amount">
              {`Save ${savings}`}
            </div>
          )}
          <div className="ml-auto text-right d-flex mr-2">
            <div className="align-self-center justify-content-start pr-2">
              <span className="text-capitalize">{deal.field_booking_type}</span>
              <h6 className="text-white small">
                {`${deal.field_savings} ${deal.field_price_type}`} from:
              </h6>{" "}
            </div>
            <h2 className="pt-1 justify-content-end">
              {`${deal.field_package_price}`}{" "}
            </h2>
          </div>
        </div>
      );
    }
  };

  const renderTabbedContent = () => {
    if (deal.field_go_id > 1 && flyer) {
      let includes =
        flyer && flyer.features._text.match(/<ul>([\s\S]*?)<\/ul>/g);

      return (
        <DealTabbedContent
          optCode={deal.field_au_tourplan_option_code}
          //includes={deal.field_includes_text}
          includes={includes[0]}
          addon={includes[1] ? includes[1] : null}
          bookingConditions={flyer.termsandconditions._text
            .replace("]]>", "")
            .replace("PACKAGE TERMS &amp; CONDITIONS:", "")}
          //itinerary={itinerary}
          itinerary={null}
        />
      );
    }

    if (deal.field_go_id < 1 && deal) {
      return (
        <DealTabbedContent
          optCode={deal.field_au_tourplan_option_code}
          //includes={deal.field_includes_text}
          includes={deal.field_includes_text}
          bookingConditions={deal.field_important_booking_conditio}
          //itinerary={itinerary}
          itinerary={null}
        />
      );
    }
  };

  const renderGoPackages = () => {
    if (deal.field_go_id > 1 && flyer) {
      const highlights = (
        <section className="bg-light pt-5 pb-3">
          <div className="container mb-5" name="highlights">
            <h2 className="text-uppercase">Highlights:</h2>

            {_.map(flyer.packages.package, (item, id) => {
              return (
                <>
                  <Row className="mt-1">
                    <div className="col-md-3">
                      <Card>
                        <Card.Img
                          variant="top"
                          className="img-fluid"
                          src={item.hotels.hotel._attributes.pic}
                        />
                      </Card>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-9 small">
                      {/* <h3 className="mt-3 font-weight-normal text-uppercase">{title}</h3> */}
                      <p>{Parser(item.hotels.hotel.description._text)}</p>
                    </div>
                  </Row>
                </>
              );
            })}
          </div>
        </section>
      );
      return highlights;
    }
  };

  if (!_.isEmpty(pkgList)) {
    const dates = deal.field_valid_for_travel.split(",");
    const saleUntil = deal.field_on_sale_until;
    const basePath = props.match.path.split("/:");
    const filteredPackages = packageFiltering(packages, basePath[0]);

    //const path = props.location.pathname;
    const flyersTitle =
      deal.field_viva_consumer_file_uploads_1 &&
      deal.field_viva_consumer_file_uploads_1.split(",");
    const flyersPath =
      deal.field_viva_consumer_file_uploads &&
      deal.field_viva_consumer_file_uploads.split(",");
    const destGuideImage = deal.field_brochure_image;
    const destGuideLink = deal.field_brochure_link;
    const dealUrl = BASE.CONFIG.SITE_BASE + props.location.pathname;
    const title = deal.field_vc_deal_title
      ? deal.field_vc_deal_title
      : deal.title;
    const location = deal.field_local_location;
    const packagePath = props.match.params.title;

    let pkgDeal = _.filter(packages, { field_path: packagePath });

    //image carousel
    let gallery = deal.field_carousel;

    let priceAddList =
      deal.field_price_add_on && deal.field_price_add_on.split("_ ");

    //let includes = flyer && flyer.features._text.match(/<ul>[\s\S]*?<\/ul>/g);
    //let includes = flyer && flyer.features._text.match(/<ul>([\s\S]*?)<\/ul>/g);

    // let includes =
    //   flyer &&
    //   flyer.features._text.replace(/<(div|\/div|br|p|\/p)[^>]{0,}>/g, "");

    // console.log(flyer);

    return (
      <>
        <META
          title={Parser(title)}
          description={deal.field_package_description_1}
          image={deal.field_main_image}
          url={dealUrl}
        />
        {/* <Row>
          <SocialContainer path={props.location.pathname} />
        </Row> */}
        <Row className="mb-4">
          <Container>
            <SocialContainer path={props.location.pathname} />
            <Title title={Parser(title)} pkg={pkgDeal[0]} />

            {!gallery.includes("default_images") && (
              <DealCarousel images={gallery.split(",")} />
            )}
          </Container>
        </Row>
        <Row>
          <Col>
            <Container>
              {location && (
                <div className="d-flex">
                  <div className="deal-destination mt-1 mb-1 font-weight-bold text-uppercase">
                    <i className="fas fa-map-marker-alt pr-1"></i>
                    <strong>{location}</strong>
                  </div>
                </div>
              )}

              {/* Total Number of Nights */}
              {/* <div className="sale-dates mt-3">
                <strong>Number of Nights:</strong> {deal.field_savings}
              </div> */}
              {/* Sale Until */}
              {saleUntil && (
                <div className="sale-dates">
                  <strong>On Sale Until:</strong> {saleUntil}
                </div>
              )}
              {/* Travel Dates */}
              {dates != "" && <div>{renderTvlBetween(dates)}</div>}
              {/* Package Description Section */}
              <div className="mt-4 package-description">
                {Parser(deal.field_package_description)}
              </div>

              <div className="mt-4 package-description">
                {renderGoPackages()}
              </div>

              <div className="mt-4 package-description">
                {renderTabbedContent()}
              </div>
              {/* )} */}

              {/* Price and Savings Section */}

              {renderPriceBar()}

              {priceAddList && (
                <div>{deal && renderPriceAddonLabel(dates, priceAddList)}</div>
              )}

              <Row>
                {destGuideLink &&
                  renderDestGuide(destGuideImage, destGuideLink)}
                {flyersTitle && renderFileList(flyersPath, flyersTitle)}
              </Row>
              {/* {deal.field_important_booking_conditio &&
                renderBookingConds(deal.field_important_booking_conditio)} */}
              {/* {renderContentCards(data.view, premPage, path)} */}
            </Container>
          </Col>
          {/* Enquire and Other Deals Section */}
          <Col sm="12" md="4">
            {renderEnquireBook(deal)}

            {/* {pkgList && renderCurrentPackageList(pkgList, deal.nid)} */}
            {!premPage &&
              renderCurrentDealList(
                deal.nid,
                pkgList,
                basePath[0],
                pkgDeal[0].title
              )}
            {/* {renderImageGallery(data)} */}
          </Col>
          {/* ENQUIRY MODAL */}
          <Modal size="md" show={show} onHide={handleClose}>
            <Modal.Header className="text-uppercase p-5" closeButton>
              <Modal.Title>
                <h2>Make an Enquiry</h2>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="booking-form p-5">
              <EnquiryForm
                title={Parser(title)}
                nights={deal.field_savings}
                dealURL={dealUrl}
              />
            </Modal.Body>
            {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
          </Modal>
          {/* {!gallery.includes("default_images") && renderImageGallery(gallery)} */}
        </Row>
      </>
    );
  }

  return loader();
};

export default DealPage;
